import { ReactElement } from 'react';
import styles from './ui-menu-group-label.module.scss';
import { UIText } from '../ui-text';

type UIMenuGroupLabelProps = { text: string };
export function UIMenuGroupLabel(props: UIMenuGroupLabelProps): ReactElement {
    const { text } = props;
    return (
        <div className={styles.container}>
            <UIText medium variant="small">
                {text}
            </UIText>
        </div>
    );
}
